<template>
  <div class="main-content">
    <!-- Filters -->
    <div class="row">
      <div class="col-md-3">
        <div class="card">
          <div class="card-header">
            <div class="card-title">
              Filtros
              <button
                class="btn btn-inform"
                data-container="body"
                data-toggle="popover"
                data-content="É possível fazer seleção múltipla."
              >
                <i class="fas fa-info-circle"></i>
              </button>
            </div>
          </div>
          <div class="card-body">
            <div class="form-group">
              <label for="filterCompany">Empresa</label>
              <v-select
                :options="companies"
                label="fantasy_name"
                :reduce="(companies) => companies.id"
                class="style-chooser"
                id="companies"
                multiple
                v-model="filters.company_id"
                v-on:input="getBatches"
              >
                <div slot="no-options">Nenhum registro encontrado.</div>
              </v-select>
            </div>
            <div class="form-group">
              <label for="filterBranch">Unidade</label>
              <v-select
                :options="filteredBranches"
                label="name"
                :reduce="(filteredBranches) => filteredBranches.id"
                class="style-chooser"
                id="branches"
                multiple
                v-model="filters.branch_id"
                v-on:input="getBatches"
              >
                <div slot="no-options">Nenhum registro encontrado.</div>
              </v-select>
            </div>
            <div class="form-group">
              <label for="filterSection">Departamento</label>
              <v-select
                :options="filteredSectors"
                label="name"
                :reduce="(filteredSectors) => filteredSectors.id"
                class="style-chooser"
                id="sectors"
                multiple
                v-model="filters.sector_id"
                v-on:input="getBatches"
              >
                <div slot="no-options">Nenhum registro encontrado.</div>
              </v-select>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-9">
        <div class="card">
          <div class="card-header">
            <div class="card-title">Gerenciamento de Lotes</div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <p class="mb-0">Faça sua busca por:</p>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <datetime
                    v-model="filters.dateStart"
                    class="form-control along"
                    :phrases="{ ok: 'Ok', cancel: 'Cancelar' }"
                    value-zone="America/Sao_Paulo"
                    zone="America/Sao_Paulo"
                    placeholder="Data início"
                    v-on:input="getBatches"
                  ></datetime>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <datetime
                    v-model="filters.dateEnd"
                    class="form-control along"
                    :phrases="{ ok: 'Ok', cancel: 'Cancelar' }"
                    value-zone="America/Sao_Paulo"
                    zone="America/Sao_Paulo"
                    placeholder="Data fim"
                    v-on:input="getBatches"
                  ></datetime>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control along"
                    id="filterSearch"
                    placeholder="Palavra chave..."
                    v-model="filters.docto"
                    @keyup="getBatches"
                  />
                </div>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-12">
                <p class="mb-3">Selecione o status dos documentos:</p>
              </div>
              <div class="col-md-3">
                <input
                  type="checkbox"
                  value="1"
                  v-model="filters.signed"
                  @change="getBatches"
                  id="signed"
                  name="signed"
                />
                <label for="signed">
                  <i
                    class="fas fa-file-contract"
                    style="margin-left: 10px; margin-right: 10px"
                  ></i>
                  Assinado
                </label>
              </div>
              <div class="col-md-3">
                <input
                  type="checkbox"
                  v-model="filters.pending"
                  value="1"
                  @change="getBatches"
                  id="pending"
                  name="pending"
                />
                <label for="pending">
                  <i
                    class="fas fa-file-contract"
                    style="margin-left: 10px; margin-right: 10px"
                  ></i>
                  Pendente
                </label>
              </div>
              <div class="col-md-3">
                <input
                  type="checkbox"
                  v-model="filters.late"
                  value="1"
                  @change="getBatches"
                  id="late"
                  name="late"
                />
                <label for="late">
                  <i
                    class="fas fa-file-contract"
                    style="margin-left: 10px; margin-right: 10px"
                  ></i>
                  Atrasado
                </label>
              </div>
              <div class="col-md-3">
                <input
                  type="checkbox"
                  v-model="filters.cancel"
                  value="1"
                  @change="getBatches"
                  id="cancel"
                  name="cancel"
                />
                <label for="cancel">
                  <i
                    class="fas fa-file-contract"
                    style="margin-left: 10px; margin-right: 10px"
                  ></i>
                  Cancelado
                </label>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-12">
                <div class="table-responsive">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th scope="col">ID</th>
                        <th scope="col">Nome do Lote</th>
                        <th scope="col">Data do Envio</th>
                        <th scope="col">Qtd. Enviados</th>
                        <th scope="col">Qtd. Assinados</th>
                        <th scope="col">Status</th>
                        <th scope="col">Ação</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="batch in batches" :key="batch.id">
                        <td>{{ batch.id }}</td>
                        <td>{{ batch.name }}</td>
                        <td>{{ batch.sent_at }}</td>
                        <td>{{ batch.total_sents }}</td>
                        <td>{{ batch.completed }}</td>
                        <td>
                          <span
                            class="badge"
                            :class="[
                              batch.total_sents == batch.completed
                                ? 'pastel-green'
                                : batch.late == 0 && batch.canceled_at == null
                                ? 'pastel-yellow'
                                : 'pastel-red',
                            ]"
                            >{{
                              batch.canceled_at != null
                                ? "Cancelado"
                                : batch.total_sents == batch.completed
                                ? "Concluído"
                                : batch.late > 0
                                ? "Atrasado"
                                : "Pendente"
                            }}</span
                          >
                        </td>
                        <td>
                          <a
                            :href="'../view/' + batch.id"
                            target="_blank"
                            class="btn btn-crud view"
                            data-tooltip="tooltip"
                            title="Visualizar"
                          >
                            <i class="far fa-eye"></i>
                          </a>
                          <!-- <a
                            href="#"
                            class="btn btn-crud delete"
                            data-tooltip="tooltip"
                            title="Excluir"
                          >
                            <i class="far fa-trash-alt"></i>
                          </a>-->
                        </td>
                      </tr>
                      <tr v-if="batches.length == 0" align="center">
                        <td colspan="6">Nenhum registro encontrado.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <pagination
              :records="total"
              :options="options"
              :per-page="10"
              @paginate="getBatches"
            ></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Pagination } from "vue-pagination-2";
export default {
  data() {
    return {
      options: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
      },
      total: 0,
      companies: [],
      branches: [],
      sectors: [],
      batches: [],
      filters: {
        dateStart: "",
        dateEnd: "",
        sector_id: "",
        branch_id: "",
        company_id: "",
        docto: "",
        pending: "",
        signed: "",
        late: "",
        cancel: "",
      },
    };
  },
  computed: {
    filteredBranches: function () {
      var bcs = [];
      for (var i = 0; i <= this.filters.company_id.length; i++) {
        var b2 = this.branches.filter(
          (x) => x.company_id == this.filters.company_id[i]
        );
        bcs.push(b2[0]);
      }
      bcs.splice(i - 1);
      return bcs;
    },
    filteredSectors: function () {
      var scs = [];
      for (var i = 0; i <= this.filters.company_id.length; i++) {
        var c2 = this.sectors.filter(
          (x) => x.company_id == this.filters.company_id[i]
        );
        scs.push(c2[0]);
      }
      scs.splice(i - 1);
      return scs;
    },
  },
  methods: {
    getCompanies: function () {
      const self = this;
      const api =
        self.$store.state.api + "companies?paginated=false&with[]=branches";
      self.$http
        .get(api)
        .then((response) => {
          self.companies = response.data.data;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getBranches: function () {
      const self = this;
      const api = self.$store.state.api + "branches?paginated=false";
      self.$http
        .get(api)
        .then((response) => {
          self.branches = response.data.data;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getSectors: function () {
      const self = this;
      const api = self.$store.state.api + "sectors?paginated=false";
      self.$http
        .get(api)
        .then((response) => {
          self.sectors = response.data.data;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getBatches: function (page) {
      const self = this;
      const api =
        self.$store.state.api + "signature_management_batches?page=" + page;
      self.$http
        .post(api, {
          filters: self.filters,
        })
        .then((response) => {
          self.batches = response.data.data;
          self.total = response.data.total;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
  },
  mounted() {
    this.getCompanies();
    this.getBranches();
    this.getSectors();
    this.getBatches();
  },
  components: { Pagination },
};
</script>
<style scoped>
.date-time-picker .field-input[data-v-74507c40] {
  border: none;
  border-bottom: 2px solid #03a830;
  color: #03a830;
}
.along {
  height: 40px;
}

input[type="checkbox"] {
  position: absolute;
  z-index: -1;
  opacity: 0;
}

input[type="checkbox"] + label {
  font-size: 12px;
  padding: 2px 0 0;
  width: 100px;
  height: 25px;
  border: 2px solid #28a745;
  color: #424241;
  border-radius: 0.25rem;
}
input[type="checkbox"]:checked + label {
  border: 2px solid #03a830;
  color: #fff;
  background-color: #03a830;
  font-style: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/SignatureBatch/Management/Batches.vue